/* This file is auto-generated by build_string_refs.ts, do not modify directly */

import type { I18nKey } from '../../../i18n-key.js'

/**
 * - content: `Allow all cookies`
 * - description: Text shown in a button in a banner displayed to users in a region in which we require explicit consent from them to use any nonessential cookies in the browser. When clicked, all nonessential cookies will be enabled.
 */
export const cookiesAllowAllCookies = "cookies.allow_all_cookies" as const as I18nKey
/**
 * - content: `Consent Manager`
 * - description: Helper text for accessibility tools explaining that they are viewing a region of the page where they can manage their cookie use preferences
 */
export const cookiesConsentManager = "cookies.consent_manager" as const as I18nKey
/**
 * - content: `Cookies settings`
 * - description: Link shown in a banner at the bottom of a page that opens a page in a new tab. This page manages the user's cookie use preferences.
 */
export const cookiesCookiesSettings = "cookies.cookies_settings" as const as I18nKey
/**
 * - content: `Dismiss`
 * - description: Accessible label for the close (X) button in the cookie consent banner. Clicking the button dismisses the banner.
 */
export const cookiesDismiss = "cookies.dismiss" as const as I18nKey
/**
 * - content: `Do not allow cookies`
 * - description: Text shown in a button in a banner displayed to users in a region in which we require explicit consent from them to use any nonessential cookies in the browser. When clicked, the banner will hide and all nonessential cookies will be banned from use.
 */
export const cookiesDoNotAllowCookies = "cookies.do_not_allow_cookies" as const as I18nKey
/**
 * - content: `Do not sell or share my personal info`
 * - description: Text shown as a tooltip for a cookies widget that allows users to opt out of the sale or sharing of their personal information for advertising purposes
 */
export const cookiesDoNotSellOrShare = "cookies.do_not_sell_or_share" as const as I18nKey
/**
 * - content: `This website uses cookies, pixel tags, and local storage for performance, personalization, and marketing purposes. We use our own cookies and some from third parties. Only essential cookies are turned on by default.`
 * - description: Text shown in a cookie banner in regions where explicit consent from the user is required before we can enable any types of nonessential cookies.
 */
export const cookiesExplicitConsentBody = "cookies.explicit_consent_body" as const as I18nKey
/**
 * - content: `Manage cookies or opt out`
 * - description: Displays as the tooltip text of a button that is displayed to a user in explicit cookie consent regions after they have opted into any nonessential cookies. Clicking this text will open a new tab for a user where they can adjust their preferences for nonessential cookie use
 */
export const cookiesManageCookiesOptOut = "cookies.manage_cookies_opt_out" as const as I18nKey
